import { useFeatureIsOn } from '@growthbook/growthbook-react'

import { useRecommendedForYouArticlesQuery } from '../../../../../generated/frontend'
import { AssociatedArticles } from '../../../../../shared/components'
import type { RecommendedModelType } from '../../../../../shared/components/RecommendedForYou'
import { getModelsData, Layout, Model } from '../../../../../shared/components/RecommendedForYou'
import { ModelRecommendations } from '../../../../../shared/components/RecommendedForYou/components/ModelRecommendations/ModelRecommendations'

type AssociatedArticlesProps = React.ComponentProps<typeof AssociatedArticles>
type ContentExperimentProps = {
  recommendedModel: RecommendedModelType
} & AssociatedArticlesProps

const ContentExperiment = ({
  recommendedModel,
  position,
  ...associatedArticlesProps
}: ContentExperimentProps) => {
  const showR4U = useFeatureIsOn('DSP-025-most-recent-on-article-pages')

  if (showR4U) {
    return (
      <ModelRecommendations
        model={recommendedModel}
        whichId={'related links'}
        layout={Layout.TextLinks}
        position={position}
      />
    )
  }

  return <AssociatedArticles position={position} {...associatedArticlesProps} />
}

export const RecommendedForYouPageBody = (associatedArticlesProps: AssociatedArticlesProps) => {
  const { data, loading } = useRecommendedForYouArticlesQuery()

  if (loading) {
    return null
  }

  const allModels = getModelsData(data?.homePage.recommendations?.models ?? [])
  const recentCategoryModel = allModels[Model.RECENT_CATEGORY]

  if (recentCategoryModel) {
    return <ContentExperiment recommendedModel={recentCategoryModel} {...associatedArticlesProps} />
  }

  return <AssociatedArticles {...associatedArticlesProps} />
}
